import { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { GENDER_LIST, OTHER_OPTIONS_LIST } from 'src/utils/constants/BuyPolicy'
import { COLORS } from 'src/utils/Themes/colors'
import AgeDetailsForm from 'src/components/BuyPolicy/insuranceScreens/health/AgeDetailsForm'
import SelectedIcon from 'src/assets/Buy_Policy_Images/selected.svg'
import { useSelector } from 'react-redux'
import StatusBar from 'src/components/BuyPolicy/insuranceScreens/health/StatusBar'
import { Tooltip, Zoom } from '@mui/material'
import { COMING_SOON } from 'src/utils/constants/Ceo'

const UserDetailsForm = ({ editForm, onEdit }) => {
  const classes = useStyles()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const [isGenderSelected, setIsGenderSelected] = useState(false)
  const [gender, setGender] = useState('')

  const handleGenderSelection = (item) => {
    if (gender === item?.enum) {
      setIsGenderSelected(false)
      setGender(null)
    } else {
      setIsGenderSelected(true)
      setGender(item?.enum)
    }
  }

  useEffect(() => {
    if (guestUserDetails?.userDetails?.gender) {
      setIsGenderSelected(true)
      setGender(guestUserDetails?.userDetails?.gender)
    }
  }, [guestUserDetails?.userDetails?.gender])

  return (
    <div className={classes.mainContainer}>
      <StatusBar
        statusValues={{
          first: 40,
        }}
      />
      <span className={classes.title}>Who are you?</span>
      <div className={classes.mainOptionsContainer}>
        {GENDER_LIST?.map((genderListItem, index) => {
          return (
            <div
              key={genderListItem?.label}
              id={`genderListItem_${index}`}
              className={classes.genderSelector}
              onClick={() => handleGenderSelection(genderListItem)}
            >
              <img
                src={genderListItem?.icon}
                alt={genderListItem?.label}
                className={classes.genderImage}
              />
              <span className={classes.genderLabel}>
                {genderListItem?.label}
              </span>
              {isGenderSelected && genderListItem?.enum === gender && (
                <div className={classes.genderSelected}>
                  <img
                    src={SelectedIcon}
                    alt={'Gender Selected'}
                    className={classes.genderSelectedImage}
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>
      {!isGenderSelected ? (
        <>
          <div className={classes.separator}>
            <span className={classes.separatorText}>or</span>
          </div>
          <div className={classes.optionsContainer}>
            {OTHER_OPTIONS_LIST?.map((otherOptionsListItem, index) => {
              return (
                <div
                  key={otherOptionsListItem?.label}
                  id={`otherOptionsListItem_${index}`}
                  className={classes.otherOption}
                >
                  <span className={classes.optionDescription}>
                    {otherOptionsListItem?.description}
                  </span>
                  <Tooltip
                    TransitionComponent={Zoom}
                    placement='bottom'
                    title={COMING_SOON}
                    arrow
                  >
                    <span className={classes.optionLabel}>
                      {otherOptionsListItem?.label}
                    </span>
                  </Tooltip>
                </div>
              )
            })}
          </div>
          <div className={classes.helperText}>
            <span>WE ARE</span>
            <span>MAD OVER INSURANCE</span>
          </div>
        </>
      ) : (
        <>
          <AgeDetailsForm gender={gender} editForm={editForm} onEdit={onEdit} />
        </>
      )}
    </div>
  )
}

export default UserDetailsForm

const useStyles = makeStyles({
  mainContainer: {
    background: 'linear-gradient(185.98deg, #CEF3FF -18.56%, #FFFFFF 67.98%)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    borderRadius: '10px',
    paddingTop: '40px',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '20px',
    marginTop: '50px',
  },
  mainOptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '25px',
    padding: '20px',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '15px',
    padding: '20px',
    '@media (max-width:1024px)': {
      flexWrap: 'wrap',
    },
  },
  genderSelector: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.WHITE,
    padding: '20px',
    borderRadius: '10px',
    cursor: 'pointer',
    overflow: 'hidden',
    width: '75px',
    position: 'relative',
    boxShadow: '0px 5px 10px 0px #0000001A',
    gap: '10px',
    border: '1px solid #ffffff',
    '&:hover': {
      border: '1px solid #4dc3e3',
    },
  },
  genderSelected: {
    backgroundColor: '#4dc3e3',
    width: '30px',
    height: '30px',
    bottom: '-8px',
    right: '-8px',
    position: 'absolute',
    display: 'flex',
    borderTopLeftRadius: '18px',
  },
  genderSelectedImage: {
    width: '15px',
    height: '15px',
    padding: '5px',
  },
  genderImage: {
    height: '50px',
    width: '50px',
  },
  genderLabel: {
    fontSize: '14px',
  },
  separator: {
    height: '35px',
    width: '35px',
    borderRadius: '50px',
    background: '#DEEDF3',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
  separatorText: {
    fontSize: '14px',
    color: '#668D9C',
  },
  otherOption: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    background:
      'linear-gradient(180deg, rgba(124, 173, 196, 0.2) 0%, rgba(255, 255, 255, 0) 50%)',
    padding: '25px 0px',
    borderRadius: '10px',
    gap: '5px',
    width: '100%',
    height: '70px',
    textAlign: 'center',
    '@media (max-width:1100px)': {
      width: '70%',
    },
  },
  optionDescription: {
    fontSize: '12px',
    color: '#2E3F44',
    width: '100%',
    // height:'25px',
  },
  optionLabel: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#2A90BC',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  helperText: {
    fontSize: '38px',
    fontWeight: '300',
    textAlign: 'right',
    color: '#D4D4D4',
    display: 'flex',
    flexDirection: 'column',
    // marginTop: '30px',
  },
})
